import { Link } from "react-router-dom";
import type { AnimeWork } from "@/types";
import { categories } from "@/mocks/site";

export default function WorkCard({ work }: { work: AnimeWork }) {
  const category = categories.find((item) => item.id === work.category);

  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`《${work.title}》动画封面插画`}
          width={600}
          height={800}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-500 text-foreground-800">
          {work.year} · {work.season}季
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-1.5 text-xs text-primary-600">
          <i className={category?.icon || "ri-bookmark-line"} aria-hidden="true"></i>
          <span>{category?.name}</span>
        </div>
        <h3 className="mt-2 font-heading text-base font-600 text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{work.titleJp}</p>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {work.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="truncate">{work.studio}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-play-list-2-line" aria-hidden="true"></i>
            {work.episodes} 集
          </span>
        </div>
      </div>
    </Link>
  );
}